module.exports = __webpack_public_path__ + "media/images/camera-icon-e94d54f1dec468b4289c2b349c7cc3af.png";